import { PureComponent } from 'react';
import { LoadingFlow } from '@Green-Dot-Corporation/eureka-ui-loading';
import { BrowserRouter } from 'react-router-dom';
import AppLoader from './components/loaders/AppLoader';
import AnalyticEngine from './components/analytics/AnalyticEngine';
import { setupBranding } from './services/brandingService';
import { getAppConfig } from './services/appService';

// Styles
import './styles/blue-sky-app.scss';

export default class BlueSkyApp extends PureComponent {
    state = {
        isLoading: true,
        hasError: false,
    };

    render() {
        const { isLoading, appConfig, hasError } = this.state;

        return (
            <LoadingFlow
                isLoading={isLoading}
                hasError={hasError}
                errorStateLocale={{ title: 'Error' }}
                loadingStateLocale={{ title: 'Loading' }}
            >
                <AnalyticEngine appConfig={appConfig} />
                <BrowserRouter>
                    <AppLoader appConfig={appConfig} />
                </BrowserRouter>
            </LoadingFlow>
        );
    }

    componentDidMount() {
        this.fetchConfigs();
    }

    fetchConfigs = async () => {
        const newState = {
            isLoading: false,
        };

        try {
            const appConfig = await getAppConfig();

            await setupBranding(appConfig);
            newState.appConfig = appConfig;
        } catch (e) {
            newState.hasError = true;
        } finally {
            this.setState(newState);
        }
    };
}
